
import React, { useState, useEffect, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

// COMPONENTS
import Header from "./components/Navbar";
import Hero from "./components/Home";
import Stats from "./components/Stats";
import About from "./components/About";
import Services from "./components/Services";
import Projects from "./components/Projects";

import ClientReview from "./components/clientreview";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import BackToTop from "./components/BackToTop";
import Team from "./components/Team";
import PartnerLogos from "./components/PartnerLogos";
import Careers from "./components/Careers";
import WarehouseSection from "./components/WarehouseSection";
import MapFooter from "./components/MapFooter";


// 🆕 YOUR NEW SECTIONS (as part of HOME PAGE)
import BatteryStorage from "./components/BatteryStorage";
import RooftopSolar from "./components/RooftopSolar";
import Structure from "./components/Structure"; // 🆕 Structure section


function App() {
  const [showPreloader, setShowPreloader] = useState(true);

  useEffect(() => {
    AOS.init({ duration: 800, easing: "ease-in-out", once: true });
    const timer = setTimeout(() => setShowPreloader(false), 800);
    return () => clearTimeout(timer);
  }, []);

  // HOME PAGE
  const HomePage = () => (
    <>
      <Header />
      <Hero />
      <Stats />
      <About />

      {/* 🆕 Battery Storage — About ke baad */}
      <BatteryStorage />

      {/* 🆕 Structure Section — BatteryStorage ke baad */}
      <Structure />
      <Services />
      <PartnerLogos />
      <Projects />

      {/* 🆕 Rooftop Solar — Modules ke baad */}
      <RooftopSolar />
      <Team />
      <Careers />
      <WarehouseSection />

      {/* 🆕 Client Reviews — Warehouse ke baad */}
      <ClientReview />
      <Contact />

      <MapFooter />
      <Footer />
      <WhatsAppButton />
      {/* <BackToTop /> */}
    </>
  );

  return (
    <Router>
      {/* PRELOADER */}
      {showPreloader && (
        <div className="preloader">
          <div className="preloader-inner">
            <div className="preloader-circle"></div>
          </div>
        </div>
      )}

      <Suspense
        fallback={
          <div className="preloader">
            <div className="preloader-inner">
              <div className="preloader-circle"></div>
            </div>
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<HomePage />} />

        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
